import { render, staticRenderFns } from "./xy3.vue?vue&type=template&id=f435a794&scoped=true&"
import script from "./xy3.vue?vue&type=script&lang=js&"
export * from "./xy3.vue?vue&type=script&lang=js&"
import style0 from "./xy3.vue?vue&type=style&index=0&id=f435a794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f435a794",
  null
  
)

export default component.exports